import React, {Fragment, useEffect, useState} from 'react';
import RestClient from "../../RestAPI/RestClient";
import AppUrl from "../../RestAPI/AppUrl";
import cogoToast from "cogo-toast";
import {Button, Col, Modal, Row} from "react-bootstrap";
import {useSelector} from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import LoadingText from "../Loading/LoadingText";
import DatePicker from "react-datepicker";
import appUtility from "../../RestAPI/AppUtility";

const GoogleMap = () => {
    let state=useSelector((state)=> state);
    const[DataStatus, setDataStatus]=useState(false);
    const [DataLength, setDatalength]=useState(0)
    const [markers, setMarkers] = useState([]);
    const [Division, setDivision]=useState([]);
    const [Circle, setCircle]=useState([]);
    const [MapBin, setMapBin]=useState([]);
    const [BinNameOnMap, setBinNameOnMap]=useState();
    const [DataRevenueOnMap, setDataRevenueOnMap]=useState([]);
    const [ColumnRevenueOnMap, setColumnRevenueOnMap]=useState([{}]);
    const [VisitDate, setVisitDate] = useState(new Date());

    const [ShowRevenueOnMap, setShowRevenueOnMap] = useState(false);
    const handleCloseRevenueMapHistory = () => setShowRevenueOnMap(false);
    const handleShowRevenueMapHistory = () => setShowRevenueOnMap(true);

    useEffect(() => {
        const loadMap = () => {
            const map = new window.google.maps.Map(document.getElementById('map'), {
                center: { lat: 23.845899, lng: 90.257224 },
                zoom: 12,
            });

            // ✅ Add markers to map
            markers.forEach((markerData) => {
                const marker = new window.google.maps.Marker({
                    position: {
                        lat: parseFloat(markerData.Lat),
                        lng: parseFloat(markerData.Lng),
                    },
                    map,
                    title: markerData.Name,
                });

                marker.addListener('click', () => {
                    setBinNameOnMap(markerData.Name);
                    setMapBin(markerData.BIN);
                    getRevenueHistoryOnMap(markerData.BIN);
                });
            });
        };

        if (markers.length > 0) {
            if (!window.google) {
                const script = document.createElement('script');
                script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyDZeBZiyhjxAw2pNjRE0Rqah4NXO0uCsJs`;
                script.async = true;
                script.onload = loadMap;
                document.head.appendChild(script);
            } else {
                loadMap();
            }
        }
    }, [markers]);


    const getRevenueHistoryOnMap=(BIN)=>{

        let jsonObject={"sql":" SELECT July_24,July_25,August_24,August_25,September_24,September_25,October_24,October_25,November_24,November_25,December_24,December_25,January_25,January_26,February_25,February_26,March_25,March_26,April_25,April_26,May_25,May_26,June_25,June_26" +
                ",(July_24+August_24+September_24+October_24+November_24+December_24+January_25+February_25+March_25+April_25+May_25+June_25)As Total_Last_Year," +
                "(July_25+August_25+September_25+October_25+November_25+December_25+January_26+February_26+March_26+April_26+May_26+June_26)As Total_Upto FROM nbr.revenue_25_26_view where BIN='"+BIN+"' "};
        setColumnRevenueOnMap([{}]);setDataRevenueOnMap([])
        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{

            if(result==""){cogoToast.error("Data not found");}else {
                await setColumnRevenueOnMap(
                    Object.keys(result[0]).map((k) => {
                        return {dataField: k, text: k, sort: true}
                    })
                )
                await setDataRevenueOnMap(result);

                handleShowRevenueMapHistory();

            }
        }).catch(error=>{ });

    }
    const getMapBIN=()=>{
        setDataStatus(true);
        setDatalength(0)
        const Category=document.getElementById("cmbMapCategory");
        const CategoryValue=Category.options[Category.selectedIndex].text;

        const Commi=document.getElementById("cmbBinCommi");
        const CommiValue=Commi.options[Commi.selectedIndex].text;

        const Division=document.getElementById("cmbBinDivision");
        const DivisionValue=Division.options[Division.selectedIndex].text;


        const Circle=document.getElementById("cmbBinCircle");
        const CircleValue=Circle.options[Circle.selectedIndex].text;

        const Range=document.getElementById("cmbMapRange");
        const RangeValue=Range.options[Range.selectedIndex].text;

        const Items=document.getElementById("cmbMapItems");
        const ItemsValue=Items.options[Items.selectedIndex].text;
        const SmArea=document.getElementById("txtSmArea").value;

        const BinIvasStatus=document.getElementById("cmbBinIvasStatus");
        const BinIvasStatusValue=BinIvasStatus.options[BinIvasStatus.selectedIndex].text;


        const DataLimit=document.getElementById("cmbDataLimit");
        const DataLimitValue=DataLimit.options[DataLimit.selectedIndex].text;
        const SearchBin=document.getElementById("txtSearchBin").value;



        let getCommi=" ";
        let getDivision=" ";
        let getCircle=" ";
        let getCategory=" ";
        let getItems="";
        let getFloorSpace;
        let getlimit ;
        let getBinStatus="" ;
        let getBin="";
        let getName="";

        let getSmArea=""
        let jsonObject;
        let getRange="";
        if(state.accessCom=="NBR")
        {if(Commi.selectedIndex!=0){getCommi="And Commissionerate Like '%"+CommiValue+"%'"}}
        else{getCommi="And Commissionerate Like '%"+state.accessCom+"%'"}

        if(state.accessDiv=="All Division"){if(Division.selectedIndex!=0){getDivision="And Division Like '%"+DivisionValue+"%'"}}
        else{getDivision="And Division Like '%"+state.accessDiv+"%'"}

        if(state.accessCir=="All Circle"){if(Circle.selectedIndex!=0){getCircle="And Circle Like '%"+CircleValue+"%'"}}
        else {getCircle="And Circle Like '%"+state.accessCir+"%'"}

        if(Range.selectedIndex!=0){getRange="And Range_Name ='"+RangeValue+"'"}
        if(BinIvasStatus.selectedIndex !=0){getBinStatus=" And BIN_Status ='"+BinIvasStatusValue+"' " }


        if(Category.selectedIndex!=0){getCategory="And Economic_Activity Like '%"+CategoryValue+"%' OR Manufacturing_Area Like '%"+CategoryValue+"%' OR Service_Area Like '%"+CategoryValue+"%' "}
        if(SmArea!=""){getCategory="And Economic_Activity Like '%"+SmArea+"%' OR Service_Area Like '%"+SmArea+"%' OR Manufacturing_Area Like '%"+SmArea+"%' "}
        if(Items.selectedIndex!=0){getItems="And Category= '"+ItemsValue+"'"}

        if(SearchBin!=""){ getBin=" And BIN Like '%"+SearchBin+"%'"}





        if(DataLimit.selectedIndex!=0){getlimit=" LIMIT " +DataLimitValue;
            jsonObject={"sql":"SELECT visit_BIN.Name,visit_BIN.BIN,visit_BIN.Lat,visit_BIN.Lng FROM BIN inner join visit_BIN on bin.BIN=visit_BIN.BIN where" +
                    " Visit_Bin.Visit_Date='"+appUtility.getDate(VisitDate)+"' "+getDivision+" "+getCircle+" "+getRange+" "+getItems+" "+getlimit+"  "}

        }else{getlimit="";
            jsonObject={"sql":" Select count(BIN)AS 'Total BIN' from Bin where 1=1 "}

        }


        RestClient.PostRequest(AppUrl.getData,jsonObject).then(async result=>{
            setDatalength(result.length)
            if(result==""){cogoToast.error("Data not found");setDataStatus(false)}else {

                await setMarkers(result);
                setDataStatus(false);
            }
        }).catch(error=>{ setDataStatus(false);});
    }

    return (
        <Fragment>



            <div >
                <Row className="mt-2">

                    <Col lg={3}>
                        <div className="">
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">NBR</label></Col>
                                <Col lg={9}  xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbBinCommi"
                                            onChange={()=>{
                                                setDivision([]);
                                                setCircle([]);
                                                const e = document.getElementById("cmbBinCommi");
                                                const value = e.options[e.selectedIndex].value;
                                                const dt=state.division.filter(x => x.Commissionerate_Id==value);
                                                setDivision(dt)


                                            }}
                                    >
                                        <option >NBR</option>
                                        {
                                            state.commi.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }
                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Division</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbBinDivision"
                                            onChange={()=>{
                                                setCircle([])
                                                const e = document.getElementById("cmbBinDivision");
                                                const value = e.options[e.selectedIndex].value;
                                                const dt=state.circle.filter(x => x.Division_Id==value);
                                                setCircle(dt)


                                            }}
                                    >
                                        <option >All Division</option>

                                        {
                                            Division.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }
                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Circle</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbBinCircle" >
                                        <option >All Circle</option>

                                        {
                                            Circle.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }


                                    </select>
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Range</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbMapRange"  >
                                        <option >All Range</option>
                                        <option >Range-1</option>
                                        <option >Range-2</option>
                                        <option >Range-3</option>
                                        <option >Range-4</option>
                                        <option >Range-5</option>
                                        <option >Range-6</option>
                                        <option >Range-7</option>
                                        <option >No Range</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">Category</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbMapCategory"  >
                                        <option >All Category</option>
                                        <option >Manufacturing</option>
                                        <option >Services</option>
                                        <option >Other</option>
                                        <option >Imports</option>
                                        <option >Exports</option>
                                        <option >Construction</option>
                                        <option >Wholesale</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3} xs={4}><label className="text-danger fw-bold">S/M Area</label></Col>
                                <Col lg={9} xs={8}>
                                    <input type="text" className="w-100" id="txtSmArea"/>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Items</label></Col>
                                <Col lg={9} xs={8}>
                                    <select className="float-start w-100 customfontsize" id="cmbMapItems"  >
                                        <option value="0">All Items</option>
                                        {
                                            state.category.map((ctr,index)=>{
                                                return (
                                                    <option key={index} value={ctr.Id}>{ctr.Name}</option>
                                                )
                                            })

                                        }

                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">BIN Status</label></Col>
                                <Col lg={9}xs={8}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbBinIvasStatus"  >
                                        <option >All</option>
                                        <option >Active</option>
                                        <option >Cancelled</option>
                                        <option >Suspended</option>
                                        <option >Locked</option>
                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">BIN</label></Col>
                                <Col lg={9}xs={8}>
                                    <input type="text" className="w-100" id="txtSearchBin"/>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Name</label></Col>
                                <Col lg={9}xs={8}>
                                    <input type="text" className="w-100" id="txtSearchName"/>
                                </Col>

                            </Row>
                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Visit Date</label></Col>
                                <Col lg={9}xs={8}>
                                    <DatePicker selected={VisitDate} onChange={(date) => setVisitDate(date)} dateFormat='dd-MM-yyyy' seletable  isClearable showYearDropdown scrollableMonthYearDropdown  />

                                </Col>

                            </Row>


                            <Row className="mt-2">
                                <Col lg={3}xs={4}><label className="text-danger fw-bold">Data Limit</label></Col>
                                <Col lg={9}xs={8}>
                                    <select defaultValue={100} className="float-start w-100 customfontsize" id="cmbDataLimit"  >
                                        <option >All</option>
                                        <option >100</option>
                                        <option >200</option>
                                        <option >500</option>
                                        <option >1000</option>
                                        <option >2000</option>
                                        <option >3000</option>
                                        <option >5000</option>
                                        <option >10000</option>
                                        <option >20000</option>
                                        <option >50000</option>


                                    </select>
                                </Col>

                            </Row>
                            <Row className="mt-4">
                                <Col lg={3} >

                                </Col>
                                <Col lg={9} >
                                    <button className="w-100 text-danger" onClick={getMapBIN}>Search</button>
                                </Col>


                            </Row>


                            <label className="text-danger mt-4">Data found: {DataLength}</label>

                        </div>
                    </Col>

                    <Col lg={9}>

                        {
                            DataStatus? <LoadingText/>
                                :<div id="map" style={{ width: '100%', height: '700px' }} />


                        }


                    </Col>

                </Row>
            </div>
            <Modal show={ShowRevenueOnMap} onHide={handleCloseRevenueMapHistory} dialogClassName="custom-modal-width">
                <Modal.Header closeButton>

                    <label>{BinNameOnMap}</label>
                    <hr/>
                    <label className="text-danger">:-BIN:- {MapBin}</label>

                </Modal.Header>
                <Modal.Body className="scrollable-x">
                    <div className="wide-content">
                        {<BootstrapTable  keyField='Id'  data={DataRevenueOnMap} columns={ColumnRevenueOnMap}></BootstrapTable>}
                    </div>

                </Modal.Body>
                <Modal.Footer>

                    <Button variant="danger" onClick={handleCloseRevenueMapHistory}>
                        Close
                    </Button>


                </Modal.Footer>
            </Modal>
        </Fragment>
    )


};

export default GoogleMap;
